/* src/app/features/limite-pagamento-ecg-por-terceiros/pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa.component.scss */
/*# sourceMappingURL=limite-pagamento-ecg-por-terceiros-pesquisa.component.css.map */
